/** package ir.lohebartar.commons.enums  */

export enum AppPermission {
    StaticQuiz = 'StaticQuiz',
    TopicQuiz = 'TopicQuiz',
    CustomQuiz = 'CustomQuiz',
    CreateQuizForStudents = 'CreateQuizForStudents',
    CreateClassAndStudents = 'CreateClassAndStudents',
    AddSubUsers = 'AddSubUsers',
    CreateQuestion = 'CreateQuestion',
    UseStaticQuiz = 'UseStaticQuiz',
    UseQuestions = 'UseQuestions'
}
